import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class ApiKeysService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Create api key for organization
     * @returns ApiKey New api key created.
     * @throws ApiError
     */
    createApiKey({ orgId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/api-keys', path: {
                'orgId': orgId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of api keys for organization
     * @returns ApiKeyList OK.
     * @throws ApiError
     */
    listApiKeys({ orgId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/api-keys', path: {
                'orgId': orgId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get api key by ID
     * @returns ApiKey OK.
     * @throws ApiError
     */
    getApiKeyById({ orgId, apiKeyId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/api-keys/{apiKeyId}', path: {
                'orgId': orgId,
                'apiKeyId': apiKeyId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete api key by ID
     * @returns void
     * @throws ApiError
     */
    removeApiKeyById({ orgId, apiKeyId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/api-keys/{apiKeyId}', path: {
                'orgId': orgId,
                'apiKeyId': apiKeyId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update an API key
     * Update an API key's RBAC setting. Only allows changing useRbac from true to false.
     * @returns ApiKey Successfully updated API key.
     * @throws ApiError
     */
    updateApiKeyType({ orgId, apiKeyId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/api-keys/{apiKeyId}', path: {
                'orgId': orgId,
                'apiKeyId': apiKeyId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Check Api Key
     * @returns void
     * @throws ApiError
     */
    verifyApiKey({ requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/api-keys-verify', body: requestBody, mediaType: 'application/json', errors: {
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=ApiKeysService.js.map